import { render, staticRenderFns } from "./orderTimeOut.vue?vue&type=template&id=fc2ddc9c&scoped=true&"
import script from "./orderTimeOut.vue?vue&type=script&lang=js&"
export * from "./orderTimeOut.vue?vue&type=script&lang=js&"
import style0 from "./orderTimeOut.vue?vue&type=style&index=0&id=fc2ddc9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2ddc9c",
  null
  
)

export default component.exports